import epiData from '../../epi.json';

console.log(epiData)

export default epiData;